import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent, setUserId } from 'firebase/analytics';

import { analytics } from '../../firebase';
import { useAuthContext } from '../../auth';
import { useCookiesContext } from '../../components/cookies';

export const usePageTracking = () => {
  const location = useLocation();
  const { userId } = useAuthContext();
  const { cookiesAccepted } = useCookiesContext();

  useEffect(() => {
    if (!analytics || !cookiesAccepted) return;
    setUserId(analytics, userId ?? 'unknown');
    logEvent(analytics, 'page_view', { page_path: location.pathname, custom_user_id: userId });
  }, [location, userId, cookiesAccepted]);
};
